import { Group, ScrollArea, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

/**
 * Horizontal section switcher for the Profile area (settings vs. history),
 * mirroring `AdminSubNav`'s swipeable pattern.
 */
export const ProfileSubNav = () => {
  const { t } = useTranslation();
  const PROFILE_SECTIONS = [
    { to: '/profile', label: t('profile.subnav.profile'), end: true },
    { to: '/profile/history', label: t('profile.subnav.history') },
  ];

  return (
    <ScrollArea scrollbarSize={0} type="never">
      <Group
        gap={0}
        px="md"
        style={{ borderBottom: '1px solid var(--mantine-color-ink-3)', flexShrink: 0 }}
        wrap="nowrap"
      >
        {PROFILE_SECTIONS.map((section) => (
          <NavLink end={section.end} key={section.to} to={section.to}>
            {({ isActive }) => (
              <UnstyledButton
                c={isActive ? 'signal.7' : 'ink.7'}
                ff="monospace"
                fw={700}
                px="xs"
                py="sm"
                style={{
                  backgroundColor: isActive ? 'var(--mantine-color-signal-0)' : 'transparent',
                  borderBottom: isActive
                    ? '3px solid var(--mantine-color-signal-6)'
                    : '3px solid transparent',
                  fontSize: '0.6875rem',
                  letterSpacing: '0.08em',
                  marginBottom: -1,
                  transition: 'background-color 120ms ease, color 120ms ease',
                  whiteSpace: 'nowrap',
                }}
              >
                <Group gap={8} pr="md">
                  {section.label}
                </Group>
              </UnstyledButton>
            )}
          </NavLink>
        ))}
      </Group>
    </ScrollArea>
  );
};
